import { createFileRoute, Outlet } from '@tanstack/react-router'
import { fraudAnalysisClientTypeSchema } from 'features/fraudAnalysis'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/models/$labelSlug/$clientType'
)({
  component: Outlet,
  params: {
    parse: ({ labelSlug, clientType }) => {
      const parsedClientType = fraudAnalysisClientTypeSchema.safeParse(clientType)

      if (!parsedClientType.success) {
        return false
      }

      return { labelSlug, clientType: parsedClientType.data }
    },
  },
})
